module.exports = __webpack_public_path__ + "static/mobile-body-1-3ce6e2aa4e58db2e964c213d4b368e9d.jpg";